import InternalComplianceTaskDetailsPage from "@components/common/InternalComplianceDetail/TaskDetails";
import InternalComplianceTaskHistoryPage from "@components/common/InternalComplianceDetail/TaskHistory";
import SelfComplianceTaskHistoryPage from "@components/common/SelfComplianceDetail/TaskHistory";
import ICActivitiesApprovedTaskTask from "@pages/InternalCompliance/Activities/InternalCompliance/ApprovedTask";
import ICActivitiesMyTask from "@pages/InternalCompliance/Activities/InternalCompliance/MyTask";
import ICActivitiesMyTaskCalenderView from "@pages/InternalCompliance/Activities/InternalCompliance/MyTask/calender";
import ICActivitiesPendingApprovalTask from "@pages/InternalCompliance/Activities/InternalCompliance/PendingApproval";
import UserInternalMapping from "@pages/InternalCompliance/Admin/UserEntity";
import ConfigurationInternalComplianceFieldList from "@pages/InternalCompliance/Configuration/FieldList";
import ConfigurationInternalComplianceFields from "@pages/InternalCompliance/Configuration/Fields";
import ConfigurationCustomFieldDetail from "@pages/InternalCompliance/Configuration/Fields/Detail";
import InternalMapping from "@pages/InternalCompliance/Configuration/InternalMapping";
import ICDashboardActivity from "@pages/InternalCompliance/Dashboard/Activity";
import ICDashboardSelfCompliance from "@pages/InternalCompliance/Dashboard/SelfCompliance";
import InternalComplianceReportsIC from "@pages/InternalCompliance/Reports/InternalCompliance";
import RepositoryMasterReportsIC from "@pages/InternalCompliance/Reports/InternalCompliance/Repository/MasterReports";
import RepositoryICAssignedTasks from "@pages/InternalCompliance/Repository/InternalCompliance/AssignedTasksList";
import ICAssignedTaskConfiguration from "@pages/InternalCompliance/Repository/InternalCompliance/AssignedTasksList/configure";
import RepositoryICCheckpointMaster from "@pages/InternalCompliance/Repository/InternalCompliance/Master";
import ICRepositoryEvaluator from "@pages/InternalCompliance/Repository/InternalMapping/Evaluator";
import RepositoryInternalComplianceFunctionHead from "@pages/InternalCompliance/Repository/InternalMapping/FunctionHead";
import RepositoryInternalComplianceMaster from "@pages/InternalCompliance/Repository/InternalMapping/Master";
import InternalComplianceMyTaskList from "@pages/MyTasks/internal-compliance";

export const InternalComplianceRoutes = [
  //  ------------------------------------- Configuration  ------------------------------------- //

  {
    path: "/dashboard/internal-compliance/my-activity",
    name: "dashboard_internal_compliance_my_activity",
    component: ICDashboardActivity,
  },
  {
    path: "/dashboard/internal-compliance/compliance",
    name: "dashboard_internal_compliance_compliance",
    component: ICDashboardSelfCompliance,
  },
  //  ------------------------------------- Configuration  ------------------------------------- //

  // -> Internal Compliance
  {
    path: "/configuration/internal-compliance/fields",
    name: "configuration_internal_compliance_fields",
    component: ConfigurationInternalComplianceFields,
  },
  {
    path: "/configuration/internal-compliance/fields/add",
    name: "configuration_internal_compliance_fields",
    component: ConfigurationCustomFieldDetail,
  },
  {
    path: "/configuration/internal-compliance/fields/edit/:id",
    name: "configuration_internal_compliance_fields",
    component: ConfigurationCustomFieldDetail,
  },
  {
    path: "/configuration/internal-compliance/field-list",
    name: "configuration_internal_compliance_field_list",
    component: ConfigurationInternalComplianceFieldList,
  },
  // -> Internal Mapping
  {
    path: "/configuration/internal-mapping",
    name: "configuration_mapping_internal_mapping",
    component: InternalMapping,
  },

  //  ------------------------------------- Repository  ------------------------------------- //

  // -> Internal Mapping

  {
    path: "/repository/internal-mapping/master",
    name: "repository_internal_mapping_master",
    component: RepositoryInternalComplianceMaster,
  },
  {
    path: "/repository/internal-mapping/master/task-details/:id/:checkpoint_id",
    name: "repository_internal_mapping_master",
    component: InternalComplianceTaskDetailsPage,
  },
  {
    path: "/repository/internal-mapping/master/task-history/:id/:checkpoint_id",
    name: "repository_internal_mapping_master",
    component: InternalComplianceTaskHistoryPage,
  },
  {
    path: "/repository/internal-mapping/function-head",
    name: "repository_internal_mapping_function_head",
    component: RepositoryInternalComplianceFunctionHead,
  },
  {
    path: "/repository/internal-mapping/function-head/my-tasks",
    name: "repository_internal_mapping_function_head",
    component: InternalComplianceMyTaskList,
  },
  {
    path: "/repository/internal-compliance/evaluator/my-tasks",
    name: "repository_internal_mapping_evaluator",
    component: InternalComplianceMyTaskList,
  },
  {
    path:
      "/repository/internal-mapping/function-head/task-details/:id/:checkpoint_id",
    name: "repository_internal_mapping_function_head",
    component: InternalComplianceTaskDetailsPage,
  },
  {
    path:
      "/repository/internal-mapping/function-head/task-history/:id/:checkpoint_id",
    name: "repository_internal_mapping_function_head",
    component: InternalComplianceTaskHistoryPage,
  },

  {
    path: "/repository/internal-mapping/evaluator",
    name: "repository_internal_mapping_evaluator",
    component: ICRepositoryEvaluator,
  },
  {
    path: "/repository/internal-mapping/evaluator/my-tasks",
    name: "repository_internal_mapping_evaluator",
    component: InternalComplianceMyTaskList,
  },
  
  {
    path:
      "/repository/internal-mapping/evaluator/task-details/:id/:checkpoint_id",
    name: "repository_internal_mapping_evaluator",
    component: InternalComplianceTaskDetailsPage,
  },
  {
    path:
      "/repository/internal-mapping/evaluator/task-history/:id/:checkpoint_id",
    name: "repository_internal_mapping_evaluator",
    component: InternalComplianceTaskHistoryPage,
  },
  // -> Internal Complinace

  {
    path: "/repository/internal-compliance/master",
    name: "repository_internal_compliance_company_master",
    component: RepositoryICCheckpointMaster,
  },
  {
    path: "/repository/internal-compliance/assigned-tasks",
    name: "repository_internal_compliance_assigned_tasks",
    component: RepositoryICAssignedTasks,
  },
  {
    path: "/repository/internal-compliance/assign-task-configure",
    name: "repository_internal_compliance_assigned_tasks",
    component: ICAssignedTaskConfiguration,
  },
  //  ------------------------------------- Activities ------------------------------------- //

  {
    path: "/activities/internal-compliance/my-task",
    name: "activities_internal_compliance_executor_task",
    component: ICActivitiesMyTask,
  },
  {
    path: "/activities/internal-compliance/my-task/my-tasks",
    name: "activities_internal_compliance_executor_task",
    component: InternalComplianceMyTaskList,
  },

  {
    path: "/activities/internal-compliance/my-task/calenderView",
    name: "activities_internal_compliance_executor_task",
    component: ICActivitiesMyTaskCalenderView,
  },
  {
    path:
      "/activities/internal-compliance/my-task/task-details/:id/:checkpoint_id",
    name: "activities_internal_compliance_executor_task",
    component: InternalComplianceTaskDetailsPage,
  },
  {
    path:
      "/activities/internal-compliance/my-task/task-history/:id/:checkpoint_id",
    name: "activities_internal_compliance_executor_task",
    component: InternalComplianceTaskHistoryPage,
  },

  //pending travel
  {
    path: "/activities/internal-compliance/pending-approval",
    name: "activities_internal_compliance_evaluator_approval",
    component: ICActivitiesPendingApprovalTask,
  },
  {
    path: "/activities/internal-compliance/pending-approval/my-tasks",
    name: "activities_internal_compliance_evaluator_approval",
    component: InternalComplianceMyTaskList,
  },
  {
    path:
      "/activities/internal-compliance/pending-approval/task-details/:id/:checkpoint_id",
    name: "activities_internal_compliance_evaluator_approval",
    component: InternalComplianceTaskDetailsPage,
  },
  {
    path:
      "/activities/internal-compliance/pending-approval/task-history/:id/:checkpoint_id",
    name: "activities_internal_compliance_evaluator_approval",
    component: InternalComplianceTaskHistoryPage,
  },

  //Approved Task
  {
    path: "/activities/internal-compliance/approved-task",
    name: "activities_internal_compliance_completed_task",
    component: ICActivitiesApprovedTaskTask,
  },
  {
    path:
      "/activities/internal-compliance/approved-task/task-details/:id/:checkpoint_id",
    name: "activities_internal_compliance_completed_task",
    component: InternalComplianceTaskDetailsPage,
  },
  {
    path:
      "/activities/internal-compliance/approved-task/task-history/:id/:checkpoint_id",
    name: "activities_internal_compliance_completed_task",
    component: InternalComplianceTaskHistoryPage,
  },
  //  ------------------------------------- Analytics ------------------------------------- //

  //Internal compliance reports
  {
    path: "/report/internal-compliance-reports",
    name: "report_analytics_internal_compliance",
    component: InternalComplianceReportsIC,
  },
  {
    path: "/report/internal-compliance-reports/repository-master-reports",
    name: "report_analytics_internal_compliance",
    component: RepositoryMasterReportsIC,
  },

  //  ------------------------------------- Admin ------------------------------------- //

  {
    path: "/admin/user/internal-mapping/:id",
    name: "admin_general_user",
    component: UserInternalMapping,
  },
];
